import { Injectable } from "@angular/core";
import { AuthService } from "../services/auth.service";
import { Router, RouterStateSnapshot } from "@angular/router";
import { loginRoute } from "src/app/core/routing/route-names";

@Injectable({
  providedIn: 'root'
})
export class AssetsGuard {
  constructor(private authService: AuthService, private router: Router) {}

  public canActivateAssets(state: RouterStateSnapshot): boolean {
    const url: string = state.url;
    if (this.authService.canUserAccessAnyAssets()) {
      return true;
    }
    this.redirect(url);
    return false;
  }

  public canActivateProductAssets(state: RouterStateSnapshot): boolean {
    const url: string = state.url;
    if (this.authService.canUserAccessProductAssets()) {
      return true;
    }

    this.redirect(url);
    return false;
  }

  public canActivateBrandLogos(state: RouterStateSnapshot): boolean {
    const url: string = state.url;
    if (this.authService.canUserAccessBrandLogos()) {
      return true;
    }
    this.redirect(url);
    return false;
  }

  public canActivateAssetStorage(state: RouterStateSnapshot): boolean {
    const url: string = state.url;
    if (this.authService.canUserAccessAssetStorage()) {
      return true;
    }
    this.redirect(url);
    return false;
  }

  public canActivateAssetCollections(state: RouterStateSnapshot): boolean {
    const url: string = state.url;
    if (this.authService.canUserAccessAssetCollections()) {
      return true;
    }
    this.redirect(url);
    return false;
  }

  public canActivateAssetStorageSettings(state: RouterStateSnapshot): boolean {
    const url: string = state.url;
    if (this.authService.canUserAccessAssetStorageSettings()) {
      return true;
    }
    this.redirect(url);
    return false;
  }

  private redirect(url: string) {
    // Store the attempted URL for redirecting
    this.authService.redirectUrl = url;

    // Navigate to the login page with extras
    this.router.navigate([loginRoute]);
  }
}
